module.exports = __webpack_public_path__ + "static/media/03.c4e4f480.mp3";